
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.221 3.547V9.75c0 .344-.122.638-.367.883s-.54.367-.883.367h-11.5c-.344 0-.638-.122-.883-.367a1.204 1.204 0 01-.367-.883V3.547c.23.255.492.482.79.68 1.885 1.28 3.179 2.18 3.882 2.695.297.219.537.39.719.516.187.12.435.244.742.375.307.125.594.187.86.187h.015c.266 0 .552-.063.86-.188a4.72 4.72 0 00.734-.375c.187-.125.43-.296.726-.515.886-.64 2.183-1.54 3.89-2.695a4.31 4.31 0 00.782-.68zm0-2.297c0 .411-.127.805-.383 1.18a3.714 3.714 0 01-.953.96L9.23 5.93c-.052.036-.164.117-.336.242a7.875 7.875 0 01-.828.547 2.27 2.27 0 01-.445.21c-.141.048-.271.071-.391.071h-.016c-.12 0-.25-.023-.39-.07a2.47 2.47 0 01-.453-.211 18.405 18.405 0 01-.407-.25l-.421-.297a16.1 16.1 0 00-.329-.242c-.474-.334-1.156-.808-2.046-1.422-.891-.62-1.425-.992-1.602-1.117a3.908 3.908 0 01-.914-.899C.364 2.107.22 1.75.22 1.422c0-.406.107-.745.32-1.016.22-.27.53-.406.93-.406h11.5c.339 0 .63.122.875.367.25.245.375.54.375.883z","fill":"#4F71E8"}})])
          )
        }
      }
    